import React from 'react';
import PropTypes from 'prop-types';
import { Table } from '@mui/material';
import RefineAuthorizationListResponsiveTableHead from './RefineAuthorizationListResponsiveTableHead';
import RefineAuthorizationListResponsiveTableBody from './RefineAuthorizationListResponsiveTableBody';
import { TableContainerMaxHeight } from 'components/list/TableComponentsStyled';

const RefineAuthorizationListResponsiveTable = ({ allowedStates, userGroups, dispatch, changedRefinePermissions, authorization }) => {
  return (
    <TableContainerMaxHeight>
      <Table stickyHeader>
        <RefineAuthorizationListResponsiveTableHead userGroups={userGroups} />
        <RefineAuthorizationListResponsiveTableBody
          userGroups={userGroups}
          allowedStates={allowedStates}
          dispatch={dispatch}
          changedRefinePermissions={changedRefinePermissions}
          authorization={authorization}
        />
      </Table>
    </TableContainerMaxHeight>
  );
};
RefineAuthorizationListResponsiveTable.propTypes = {
  changedRefinePermissions: PropTypes.object.isRequired,
  allowedStates: PropTypes.array.isRequired,
  userGroups: PropTypes.array.isRequired,
  dispatch: PropTypes.func.isRequired,
  authorization: PropTypes.object.isRequired
};

export default RefineAuthorizationListResponsiveTable;
